var r=e=>`iwt-legacy::userType::${e}`;export{r as a};
//# sourceMappingURL=chunk-NMVYNPGY.mjs.map